<template>
  <main class="main">
    <form class="form" @submit.prevent="createUpdateClient">
      <fieldset class="fieldset">
        <legend class="legend">
          <PhTruck />
          <span>Informations</span>
        </legend>

        <div class="field">
          <label class="label">Raison sociale</label>
          <input type="text" class="input" v-model="client.raison_sociale" required />
        </div>
      </fieldset>
      <div class="buttons">
        <ButtonElement
          type="submit"
          color="bordeaux"
          :icon="PhFloppyDisk"
          :disabled="!cacheStore.online"
        >
          {{ clientId ? 'Modifier' : 'Ajouter' }}
        </ButtonElement>
      </div>
    </form>
  </main>
</template>

<script setup lang="ts">
import { PhFloppyDisk, PhTruck } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import { computed, type ComputedRef, onMounted, ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useFetch from '@/composables/useFetch.ts'
import { useLoadingStore } from '@/stores/loading.ts'
import { useToastStore } from '@/stores/toast.ts'
import type { ClientCreate, ClientUpdate } from '@/interfaces/Client.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()
const route = useRoute()
const router = useRouter()

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()
const toastStore = useToastStore()

// données
const client: Ref<ClientCreate | ClientUpdate> = ref({
  id: '',
  raison_sociale: '',
})

// computed
const clientId: ComputedRef<string | undefined> = computed(() => route.params.id?.toString())

// fonctions
async function getClient() {
  if (clientId.value) client.value = await cacheStore.getClient(clientId.value)
}

async function createUpdateClient() {
  loadingStore.start()
  try {
    if (clientId.value) {
      await api.put(`clients/${clientId.value}`, client.value)
    } else {
      await api.post('clients/', client.value)
    }
    toastStore.success(`Le client a bien été ${clientId.value ? 'modifié' : 'ajouté'}.`)
    await router.push({ name: 'clients' })
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getClient()
  } finally {
    loadingStore.stop()
  }
})
</script>
